<template>
	<div class="orderList">
		<back-to></back-to>
		<section class="orderList-content">
			<!-- 选项卡 -->
			<div class="orderList-tabs">
				<span :class="current == 0 ?'currentActive':''" :data-current="0" @click="change(0)">
					<img :src="current == 0?'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_01a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_01.png'"
						alt="">
					<p>全部订单</p>
				</span>
				<span :class="current == 1 ?'currentActive':''" :data-current="1" @click="change(1)">
					<img :src="current == 1 ? 'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_03a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_03.png'"
						alt="">
					<p>补充资料</p>
				</span>
				<span :class="current == 3 ?'currentActive':''" :data-current="3" @click="change(3)">
					<img :src="current == 3 ? 'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_04a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_04.png'"
						alt="">
					<p>待出行</p>
				</span>
				<span :class="current == 4 ?'currentActive':''" :data-current="4" @click="change(4)">
					<img :src="current == 4 ? 'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_05a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_05.png'"
						alt="">
					<p>出行中</p>
				</span>
				<span :class="current == 6 ?'currentActive':''" :data-current="6" @click="change(6)">
					<img :src="current == 6 ? 'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_06a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_06.png'"
						alt="">
					<p>订单完成</p>
				</span>
				<span :class="current == 10 ?'currentActive':''" :data-current="10" @click="change(10)">
					<img :src="current == 10 ? 'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_07a.png':'https://sweetour-pic.obs.myhwclouds.com/sweetour-weidian-image_07.png'"
						alt="">
					<p>退款</p>
				</span>
			</div>
			<!-- 列表 -->
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				:immediate-check="false" class="orderList-list">
				<div class="orderList-item" v-for="(item,index) in list"
					@click="$router.push({ path: '/swimorder',query:{orderId:item.orderCode}})">
					<span class="orderList-item-t">
						<p>{{item.teamType}}</p>
						<p></p>
					</span>
					<span class="orderList-item-c">
						<span>
							<img v-lazy="item.teamImgUrl" />
							<p>{{item.teamName}}</p>
						</span>
						<span>￥{{item.orderPrice}} </span>
					</span>
					<span class="orderList-item-b">订单编号:{{item.orderCode}}</span>
				</div>
			</van-list>
		</section>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'orderList',
		components: {
			BackTo
		},
		data() {
			return {
				current: 0,
				loading: false,
				finished: false,
				pageIndex: 1,
				list: []
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {},
		mounted() {
			this.getList()
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				this.$_postNew(
					this.$connectHttpSweet + '/TeamAll/GetOrderList?userID=' + this.userInfo.userId +
					'&pageIndex=' + this.pageIndex + '&pageSize=10&OrderStatus=' + this.current +
					'&OrganizationId=' + this.$organizationId, {}
				).then(res => {
					if (e) {
						this.list = res.result.teamOrders
					} else {
						this.list = this.list.concat(res.result.teamOrders)
					}
					if (res.result.teamOrders.length < 10) {
						this.finished = true;
					}
				})
			},
			change(e) {
				console.log(e)
				if (e == this.current) {
					return
				}
				if (e == 10) {
					this.$router.push({
						path: '/refundList',
						query: {
							type: 2
						}
					})
					return
				}
				this.current = e
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.pageIndex = 1
				this.getList(true)
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#fff')
		},
	}
</script>

<style scoped>
	.orderList-content {
		margin-top: @nav-bar-height;
	}

	.orderList-tabs {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 120px;
		border-bottom: 1px solid #e6e6e6;
		font-size: 24px;
		position: fixed;
		top: @nav-bar-height;
		background-color: #fff;
	}

	.orderList-tabs img {
		width: 40px;
		height: 40px;
	}

	.orderList-tabs span {
		display: flex;
		align-items: center;
		flex-direction: column;
		flex: 1;
		padding-top: 14px;
	}

	.orderList-tabs span p {
		padding-top: 10px;
	}

	.currentActive {
		color: #ff983f;
		font-weight: bold;
	}

	.orderList-list {
		padding-top: 120px;
		font-size: 26px;
	}


	.orderList-item img {
		width: 200px;
		height: 132px;
		margin-right: 17px;
	}

	.orderList-item-t {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 72px;
		border-bottom: 1px solid #e6e6e6;
		color: #999;
		padding: 0 20px 0 32px;
		box-sizing: border-box;
	}

	.orderList-item-t p:last-child {
		color: #ff8a00;
	}

	.orderList-item-c {
		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		padding: 20px 20px 20px 32px;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
	}

	.orderList-item-c span:first-child {
		display: flex;
		color: #333;
		font-weight: bold;
	}

	.orderList-item-b {
		height: 88px;
		border-bottom: 14px solid #e6e6e6;
		width: 100%;
		display: flex;
		align-items: center;
		padding-left: 32px;
		box-sizing: border-box;
	}
</style>